<div
  [ngClass]="[size]"
  [ngStyle]="{
    'background-color': 'var(--' + backgroundColor + ')',
    color: 'var(--' + color + ')',
  }"
  aria-label="Avatar container"
  class="flex items-center justify-center rounded-full">
  <mat-icon
    *ngIf="icon; else avatarWithLabel"
    aria-label="Avatar icon"
    class="material-icons-outlined flex items-center justify-center text-md"
    >{{ icon }}
  </mat-icon>
</div>

<ng-template #avatarWithLabel>
  <span *ngIf="avatarLabel" [ngClass]="{ 'text-sm': avatarLabel.length > 2 }" aria-label="Avatar label">{{
    avatarLabel | uppercase
  }}</span>
</ng-template>
